<mat-toolbar [ngClass]="{ 'no-padding': isXSmallViewport() }">
  <a
    routerLink="/"
    [class]="isXSmallViewport() ? 'header-container-mobile' : ''"
  >
    <div
      [class]="isBigLogo() ? 'big-logo-image-header' : 'logo-image-header'"
    ></div>
  </a>
  @if (isXSmallViewport()) {
    <button matIconButton (click)="toggleSidebar()">
      <mat-icon class="primary-symbol">
        {{ this.isSidebarOpen() ? 'menu_open' : 'menu' }}</mat-icon
      >
    </button>
  }

  <span class="spacer"></span>

  @if (showChat()) {
    <button
      data-cy="chat-link-e2e"
      matIconButton
      [routerLink]="chatRoute()"
      [matBadge]="unreadChatCount()"
      [matTooltip]="chatName()"
    >
      <mat-icon class="primary-symbol"> chat </mat-icon>
    </button>
  }
  @if (showInbox()) {
    <button
      data-cy="inbox-link-e2e"
      matIconButton
      [routerLink]="inboxRoute()"
      [matBadge]="this.unread()"
      [matTooltip]="inboxName()"
    >
      <mat-icon class="primary-symbol">stacked_email</mat-icon>
    </button>
  }
  @if (showUserCardButton()) {
    <button
      matIconButton
      matTooltip="{{ 'userCard.tooltip' | translate }}"
      (click)="toggleUserCardOpen()"
      [matBadge]="unreadNotificationsCount()"
      [matBadgeHidden]="badgeHidden()"
    >
      <mat-icon class="primary-symbol">account_circle</mat-icon>
    </button>

    @if (isUserCardOpen()) {
      <div (clickOutside)="toggleUserCardOpen()" class="user-card-container">
        <app-user-details-card />
      </div>
    }
  }
</mat-toolbar>
